import { createStore } from 'vuex';
import dates from "@/store/modules/dates";
import tokens from "@/store/modules/tokens";
import profile from "@/store/modules/profile"

export default createStore({
    modules: {
        dates,
        tokens,
        profile,
    },
    actions: {
        logout({ dispatch }){
            dispatch('dates/deleteData', null, { root: true });
            dispatch('tokens/deleteData', null, { root: true });
            dispatch('profile/deleteData', null, { root: true });
        }
    }
});
